export const booleanEnvVariable = (variable) => {
  return typeof variable !== 'undefined' &&
    Boolean(variable) &&
    variable !== 'false' &&
    variable !== '' &&
    variable !== 0

}